export const DIALOG_ANALYTICS_LABEL = 'ai_writer_dialog'
